module.exports = __webpack_public_path__ + "img/shelllist.2d328300.png";